import React from "react";
import LegalLayout from "./LegalLayout";

const PrivacyPolicy = () => (
  <LegalLayout
    title="Privacy Policy"
    subtitle="Pawansut Holdings Limited — Your data, your trust"
  >
    <p className="last-updated">Last updated: February 2025</p>
    <p className="intro">
      Pawansut Holdings Limited (&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;) is committed to
      protecting your privacy. This Privacy Policy explains how we collect, use,
      store, and disclose your personal and financial information in connection
      with our NBFC operations and digital platforms, in compliance with
      applicable Indian laws including the Information Technology Act, 2000 and
      RBI guidelines.
    </p>

    <section>
      <h2>1. Information We Collect</h2>
      <p>We may collect the following categories of information:</p>
      <ul>
        <li>
          <strong>Identity and contact:</strong> Name, date of birth, address,
          email, phone number, Aadhaar (as permitted), PAN, and similar KYC
          details.
        </li>
        <li>
          <strong>Financial:</strong> Income, employment, bank account details,
          credit history, and information related to loan or investment
          applications.
        </li>
        <li>
          <strong>Technical:</strong> IP address, device type, browser, and
          usage data when you use our website or app.
        </li>
        <li>
          <strong>Communications:</strong> Records of correspondence, calls, and
          complaints for quality and regulatory purposes.
        </li>
      </ul>
    </section>

    <section>
      <h2>2. How We Use Your Information</h2>
      <p>We use your information to:</p>
      <ul>
        <li>Process applications, disburse loans, and manage investments.</li>
        <li>Verify identity and comply with KYC/AML and regulatory requirements.</li>
        <li>Assess creditworthiness and manage risk, including sharing with credit bureaus.</li>
        <li>Communicate about products, services, and important updates.</li>
        <li>Improve our services, website, and security.</li>
        <li>Handle grievances and comply with legal and regulatory obligations.</li>
      </ul>
    </section>

    <section>
      <h2>3. Sharing and Disclosure</h2>
      <p>
        We may share your information with RBI, credit information companies,
        banks, legal and regulatory authorities, service providers (e.g.,
        technology, collection), and group entities where permitted by law. We
        do not sell your personal data to third parties for marketing.
      </p>
    </section>

    <section>
      <h2>4. Data Security</h2>
      <p>
        We implement technical and organisational measures to protect your data
        against unauthorised access, alteration, or loss. Access to personal and
        financial data is restricted to authorised personnel on a need-to-know
        basis.
      </p>
    </section>

    <section>
      <h2>5. Retention</h2>
      <p>
        We retain your information for as long as necessary to fulfil the
        purposes described in this policy and to comply with legal, regulatory,
        and contractual requirements, including RBI guidelines.
      </p>
    </section>

    <section>
      <h2>6. Your Rights</h2>
      <p>
        You may request access to, correction of, or deletion of your personal
        data where applicable under law. You can also opt out of marketing
        communications. To exercise these rights or for any privacy-related
        grievance, please contact us or our Grievance Redressal Officer.
      </p>
    </section>

    <section>
      <h2>7. Cookies and Tracking</h2>
      <p>
        Our website may use cookies and similar technologies for functionality,
        analytics, and security. You can manage cookie preferences through your
        browser settings.
      </p>
    </section>

    <section>
      <h2>8. Updates</h2>
      <p>
        We may update this Privacy Policy from time to time. The revised policy
        will be posted on our website with an updated date. We encourage you to
        review it periodically.
      </p>
    </section>

    <section>
      <h2>9. Contact</h2>
      <p>
        For privacy-related queries or complaints, please contact us via the
        &quot;Contact Us&quot; section or reach our Grievance Redressal Officer as
        mentioned in our Grievance Redressal Policy.
      </p>
    </section>
  </LegalLayout>
);

export default PrivacyPolicy;
